import { c as _c } from "react/compiler-runtime";
/**
  * Do not edit this file manually.
  * It is automatically generated.
  * Run `npm run svg:convert` to regenerate.
  */
import type React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
export default function DockToRightIcon(props) {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M5.30773 20.5C4.80901 20.5 4.38306 20.3234 4.02986 19.9702C3.67664 19.617 3.50003 19.191 3.50003 18.6923V5.30773C3.50003 4.80902 3.67664 4.38306 4.02986 4.02986C4.38306 3.67664 4.80901 3.50003 5.30773 3.50003H18.6923C19.191 3.50003 19.617 3.67664 19.9702 4.02986C20.3234 4.38306 20.5 4.80902 20.5 5.30773V18.6923C20.5 19.191 20.3234 19.617 19.9702 19.9702C19.617 20.3234 19.191 20.5 18.6923 20.5H5.30773ZM8.00001 19V5.00001H5.30773C5.2308 5.00001 5.16027 5.03206 5.09616 5.09616C5.03206 5.16027 5.00001 5.2308 5.00001 5.30773V18.6923C5.00001 18.7692 5.03206 18.8397 5.09616 18.9039C5.16027 18.968 5.2308 19 5.30773 19H8.00001ZM9.49998 19H18.6923C18.7692 19 18.8397 18.968 18.9039 18.9039C18.968 18.8397 19 18.7692 19 18.6923V5.30773C19 5.2308 18.968 5.16027 18.9039 5.09616C18.8397 5.03206 18.7692 5.00001 18.6923 5.00001H9.49998V19Z" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <SvgIcon {...props}>{t0}</SvgIcon>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}